<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left m-0">
            Cadastrar Funcionários - {{ title }}
          </h4>

          <div
            class="tab-content"
            id="pills-tabContent"
            style="min-height: 300px;"
          >
            <div
              v-show="itemMenu == 1"
              class="tab-pane fade"
              :class="itemMenu == 1 ? 'show active' : ''"
            >
              <div class="row justify-content-center mt-2">
                <div class="row">
                  <base-input
                    name="nome"
                    class="col-sm-12"
                    :class="error.nome === true ? 'has-danger' : ''"
                    required
                    placeholder="Nome"
                    v-model.trim="model.nome"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="email"
                    class="col-sm-6"
                    required
                    placeholder="E-mail"
                    v-model="model.email"
                    :error="getError('email')"
                  />
                  <base-input
                    name="matricula"
                    class="col-sm-3"
                    required
                    placeholder="Matrícula"
                    v-mask="'XXXXXXXX'"
                    v-model="model.matricula"
                    :error="getError('matricula')"
                  />

                  <base-input
                    name="2ª Matrícula"
                    class="col-sm-3"
                    required
                    placeholder="2ª Matrícula"
                    v-mask="'XXXXXXXX'"
                    v-model="model.matricula2"
                    :disabled="!model.matricula"
                    :class="error.matricula2 === true ? 'has-danger' : ''"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="codigo"
                    class="col-sm-4"
                    required
                    placeholder="Código"
                    v-mask="'##########'"
                    @blur="verificarCodigo"
                    v-model="model.codigo"
                    :error="getError('codigo')"
                  />
                  <el-select
                    name="sexo"
                    required
                    class="select-success col-sm-4 pagination-select"
                    v-model="model.sexo"
                    placeholder="Sexo"
                    :error="getError('sexo')"
                  >
                    <el-option
                      class="select-success"
                      label="Masculino"
                      value="M"
                      >Masculino</el-option
                    >
                    <el-option class="select-success" label="Feminino" value="F"
                      >Feminino</el-option
                    >
                  </el-select>
                  <base-input
                    name="telefone"
                    class="col-sm-3"
                    type="tel"
                    v-mask="'(##) #####-####'"
                    required
                    placeholder="Telefone"
                    v-model="model.telefone"
                    :error="getError('telefone')"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="dataNascimento"
                    class="col-sm-3"
                    type="tel"
                    v-mask="'##/##/####'"
                    required
                    placeholder="Data de Nascimento"
                    v-model="model.dataNascimento"
                    :error="getError('dataNascimento')"
                  />

                  <base-input
                    name="pai"
                    class="col-sm-4"
                    required
                    placeholder="Pai"
                    v-model="model.pai"
                  />
                  <base-input
                    name="mae"
                    class="col-sm-4"
                    required
                    placeholder="Mãe"
                    v-model="model.mae"
                    :error="getError('mae')"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="endereco"
                    class="col-sm-5"
                    required
                    placeholder="Endereco"
                    v-model="model.endereco"
                    :error="getError('endereco')"
                  />
                  <base-input
                    name="bairro"
                    class="col-sm-4"
                    required
                    placeholder="Bairro"
                    v-model="model.bairro"
                    :error="getError('bairro')"
                  />
                  <base-input
                    name="cep"
                    class="col-sm-3"
                    type="tel"
                    v-mask="'##.###-###'"
                    required
                    placeholder="Cep"
                    v-model="model.cep"
                    :error="getError('cep')"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="complemento"
                    class="col-sm-12"
                    placeholder="Complemento"
                    v-model="model.complemento"
                  />
                </div>

                <div class="row">
                  <el-select
                    name="uf"
                    required
                    class="select-success col-sm-2 pagination-select"
                    v-model="estadoSelecionado"
                    placeholder="Uf"
                    :error="getError('uf')"
                  >
                    <el-option
                      class="select-success"
                      v-for="item in estados"
                      :key="item.ID"
                      :label="item.Sigla"
                      :value="item.ID"
                    >
                      {{ item.Sigla }}
                    </el-option>
                  </el-select>
                  <el-select
                    name="cidade"
                    required
                    class="select-success col-sm-5 pagination-select"
                    v-model="model.cidade"
                    placeholder="Cidade"
                    :error="getError('cidade')"
                  >
                    <el-option
                      class="select-success"
                      v-for="item in cidades"
                      :key="item.ID"
                      :label="item.Nome"
                      :value="item.Nome"
                    >
                      {{ item.Nome }}
                    </el-option>
                  </el-select>
                  <el-select
                    name="grauInstrucao"
                    required
                    class="select-success col-sm-5 pagination-select"
                    v-model="model.grauInstrucao"
                    placeholder="Grau de Instrução"
                    :error="getError('grauInstrucao')"
                  >
                    <el-option
                      class="select-success"
                      label="Ensino fundamental incompleto"
                      value="Ensino fundamental incompleto"
                      >Ensino fundamental incompleto</el-option
                    >
                    <el-option
                      class="select-success"
                      label="Ensino fundamental cursando"
                      value="Ensino fundamental cursando"
                      >Ensino fundamental cursando</el-option
                    >
                    <el-option
                      class="select-success"
                      label="Ensino fundamental completo"
                      value="Ensino fundamental completo"
                      >Ensino fundamental completo</el-option
                    >
                    <el-option
                      class="select-success"
                      label="Ensino médio incompleto"
                      value="Ensino médio incompleto"
                    >
                      Ensino médio incompleto</el-option
                    >
                    <el-option
                      class="select-success"
                      label="Ensino médio cursando"
                      value="Ensino médio cursando"
                      >Ensino médio cursando</el-option
                    >
                    <el-option
                      class="select-success"
                      label="Ensino médio completo"
                      value="Ensino médio completo"
                      >Ensino médio completo</el-option
                    >
                    <el-option
                      class="select-success"
                      label="Ensino superior incompleto"
                      value="Ensino superior incompleto"
                      >Ensino superior incompleto</el-option
                    >
                    <el-option
                      class="select-success"
                      label="Ensino superior cursando"
                      value="Ensino superior cursando"
                    >
                      Ensino superior cursando</el-option
                    >
                    <el-option
                      class="select-success"
                      label="Ensino superior completo"
                      value="Ensino superior completo"
                    >
                      Ensino superior completo</el-option
                    >
                  </el-select>
                </div>
              </div>
            </div>

            <div
              v-show="itemMenu == 2"
              class="tab-pane fade"
              :class="itemMenu == 2 ? 'show active' : ''"
            >
              <div class="row justify-content-center">
                <div class="row">
                  <base-input
                    name="ctps"
                    class="col-sm-4"
                    required
                    placeholder="CTPS"
                    v-model="model.ctps"
                  />
                  <base-input
                    name="serie"
                    class="col-sm-4"
                    required
                    placeholder="Série"
                    v-model="model.serie"
                  />
                  <base-input
                    name="dateExpedicaoCtps"
                    class="col-sm-4"
                    type="tel"
                    v-mask="'##/##/####'"
                    required
                    placeholder="Data Expedição"
                    v-model="model.dateExpedicaoCtps"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="ci"
                    class="col-sm-4"
                    required
                    placeholder="CI"
                    v-model="model.ci"
                  />
                  <base-input
                    name="orgaoExpeditor"
                    class="col-sm-4"
                    required
                    placeholder="Orgão Expeditor"
                    v-model="model.orgaoExpeditor"
                  />
                  <base-input
                    name="dateExpedicaoCi"
                    class="col-sm-4"
                    required
                    type="tel"
                    v-mask="'##/##/####'"
                    placeholder="Data Expedição"
                    v-model="model.dateExpedicaoCi"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="cpf"
                    v-if="this.$route.params.typeCad == 1"
                    class="col-sm-3"
                    type="tel"
                    v-mask="'###.###.###-##'"
                    required
                    placeholder="CPF"
                    v-model="cpf"
                    :class="error.cpf === true ? 'has-danger' : ''"
                  />
                  <base-input
                    name="cpf"
                    v-else
                    class="col-sm-3"
                    type="tel"
                    v-mask="'###.###.###-##'"
                    required
                    placeholder="CPF"
                    v-model="cpf"
                    :class="error.cpf === true ? 'has-danger' : ''"
                    disabled
                  />
                  <base-input
                    name="tituloEleitor"
                    class="col-sm-3"
                    required
                    placeholder="Título de Eleitor"
                    v-model="model.tituloEleitor"
                  />
                  <base-input
                    name="zona"
                    class="col-sm-3"
                    required
                    placeholder="Zona"
                    v-model="model.zona"
                  />
                  <base-input
                    name="secao"
                    class="col-sm-3"
                    required
                    placeholder="Seção"
                    v-model="model.secao"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="certificadoReservista"
                    class="col-sm-6"
                    required
                    placeholder="Certificado de Reservista"
                    v-model="model.certificadoReservista"
                  />
                  <base-input
                    name="categoria"
                    class="col-sm-6"
                    required
                    placeholder="Categoria"
                    v-model="model.categoria"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="pisPasep"
                    class="col-sm-6"
                    required
                    placeholder="Pis/Pasep ou use CPF Portaria 671"
                    v-mask="'###########'"
                    v-model="model.pisPasep"
                  />
                  <base-input
                    name="dataPisPasep"
                    class="col-sm-6"
                    type="tel"
                    v-mask="'##/##/####'"
                    required
                    placeholder="Data Pis/Pasep"
                    v-model="model.dataPisPasep"
                  />
                </div>
              </div>
            </div>

            <div
              v-show="itemMenu == 3"
              class="tab-pane fade"
              :class="itemMenu == 3 ? 'show active' : ''"
            >
              <div class="row justify-content-center">
                <div class="row">
                  <base-input
                    name="dataAdmissao"
                    class="col-sm-4"
                    type="tel"
                    v-mask="'##/##/####'"
                    required
                    placeholder="Data de Admissao"
                    v-model="model.dataAdmissao"
                  />
                  <base-input
                    name="horasContratadas"
                    class="col-sm-4"
                    type="tel"
                    v-mask="'###'"
                    required
                    placeholder="Horas Contratadas"
                    v-model="model.horasContratadas"
                  />
                  <base-input
                    name="valorPlano"
                    class="col-sm-4"
                    type="tel"
                    v-mask="'####'"
                    required
                    placeholder="Valor do Plano de Saúde"
                    v-model="model.valorPlanoSaude"
                  />
                </div>

                <div class="row">
                  <base-input
                    name="nrContaBancaria"
                    class="col-sm-4"
                    type="tel"
                    v-mask="'#########'"
                    required
                    placeholder="Número da Conta Bancária"
                    v-model="model.nrContaBancaria"
                  />
                  <base-input
                    name="nrBanco"
                    class="col-sm-4"
                    type="tel"
                    v-mask="'######'"
                    required
                    placeholder="Banco"
                    v-model="model.nrBanco"
                  />
                  <base-input
                    v-show="banco == 'dbsensamanaus'"
                    name="chefia"
                    class="col-sm-4"
                    required
                    placeholder="Chefia Imediata"
                    v-model="model.chefia"
                  />
                </div>

                <div class="row">
                  <el-select
                    name="funcao"
                    required
                    class="select-primary col-sm-6"
                    v-model="model.funcao"
                    placeholder="Função"
                    :class="error.funcao === true ? 'has-danger' : ''"
                  >
                    <el-option
                      v-for="item in listFuncoes"
                      :key="item.id"
                      class="select-primary"
                      :label="item.descricao"
                      :value="item.id"
                      >{{ item.descricao }}</el-option
                    >
                  </el-select>
                  <base-button
                    round
                    icon
                    type="success"
                    @click="modalCadastrarFunc = true"
                  >
                    <i class="tim-icons icon-simple-add"></i>
                  </base-button>
                  <base-button
                    round
                    :disabled="!model.funcao"
                    icon
                    type="success"
                    @click="modalEditarFunc = true"
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                  <modal :show.sync="modalCadastrarFunc">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Cadastro de Função
                      </h4>
                    </template>
                    <div>
                      <base-input
                        name="dataAdmissao"
                        class="col-sm-12"
                        placeholder="Descrição"
                        v-model.trim="descricaoCadFunc"
                      >
                      </base-input>

                      <div class="row m-0 p-0">
                        <base-checkbox
                          v-model="intrajornadaCadFunc"
                          class="col-6"
                          name="intrajornada"
                        >
                          Com Intrajornada
                        </base-checkbox>
                      </div>

                      <base-input
                        name="horaIntrajornadaCadFunc"
                        class="col-sm-12"
                        placeholder="Ex: 01:00"
                        v-model.trim="horaIntrajornadaCadFunc"
                      >
                      </base-input>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="modalCadastrarFunc = false"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        :disabled="isLoading"
                        @click="cadastrarFuncao()"
                        >Salvar</base-button
                      >
                    </template>
                  </modal>
                  <modal :show.sync="modalEditarFunc">
                    <template slot="header">
                      <h4 class="modal-title" id="edicaoFuncaoModal">
                        Edição de Função
                      </h4>
                    </template>
                    <div>
                      <base-input
                        name="dataAdmissao"
                        class="col-sm-12"
                        placeholder="Descrição"
                        v-model.trim="model.nomeFuncao"
                      >
                      </base-input>

                      <div class="row m-0 p-0">
                        <base-checkbox
                          v-model="model.intrajornada"
                          class="col-6"
                          name="intrajornada"
                        >
                          Com Intrajornada
                        </base-checkbox>
                      </div>

                      <base-input
                        name="horaIntrajornada"
                        class="col-sm-12"
                        placeholder="Ex: 01:00"
                        v-model.trim="model.horaIntrajornada"
                      >
                      </base-input>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="modalEditarFunc = false"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        :disabled="isLoading"
                        @click="editarFuncao()"
                        >Salvar</base-button
                      >
                    </template>
                  </modal>
                </div>

                <div class="row">
                  <el-select
                    name="departamento"
                    required
                    class="select-primary col-sm-6 pagination-select"
                    v-model="model.departamento"
                    placeholder="Departamento"
                    :class="error.departamento === true ? 'has-danger' : ''"
                  >
                    <el-option
                      v-for="item in listDepartamentos"
                      :key="item.id"
                      class="select-primary"
                      :label="item.descricao"
                      :value="item.id"
                      >{{ item.descricao }}</el-option
                    >
                  </el-select>
                  <base-button
                    round
                    icon
                    type="success"
                    @click="modalCadastrarDep = true"
                  >
                    <i class="tim-icons icon-simple-add"></i>
                  </base-button>
                  <base-button
                    round
                    :disabled="!model.departamento"
                    icon
                    type="success"
                    @click="modalEditarDep = true"
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                  <modal :show.sync="modalCadastrarDep">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Cadastro de Departamento
                      </h4>
                    </template>
                    <div>
                      <base-input
                        name="dataAdmissao"
                        class="col-sm-12"
                        placeholder="Descrição"
                        v-model.trim="descricaoCadDep"
                      >
                      </base-input>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="modalCadastrarDep = false"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        :disabled="isLoading"
                        @click="cadastrarDepartamento()"
                        >Salvar</base-button
                      >
                    </template>
                  </modal>
                  <modal :show.sync="modalEditarDep">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Edição de Departamento
                      </h4>
                    </template>
                    <div>
                      <base-input
                        name="dataAdmissao"
                        class="col-sm-12"
                        placeholder="Descrição"
                        v-model.trim="model.nomeDepartamento"
                      >
                      </base-input>
                    </div>
                    <template slot="footer">
                      <base-button type="danger" @click="modalEditarDep = false"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        :disabled="isLoading"
                        @click="editarDepartamento()"
                        >Salvar</base-button
                      >
                    </template>
                  </modal>
                </div>

                <!-- JORNADA ATIVO SOMENTE PARA SEMSA-->
                <div class="row" v-show="banco == 'dbsensamanaus'">
                  <el-select
                    name="id_jornada"
                    required
                    class="select-primary col-sm-6 pagination-select"
                    v-model="model.id_jornada"
                    placeholder="Jornada"
                    :class="error.id_jornada === true ? 'has-danger' : ''"
                  >
                    <el-option
                      v-for="item in listJornadas"
                      :key="item.id"
                      class="select-primary"
                      :label="item.descricao"
                      :value="item.id"
                      >{{ item.descricao }}</el-option
                    >
                  </el-select>
                  <base-button
                    round
                    icon
                    type="success"
                    @click="modalCadJornada = true"
                  >
                    <i class="tim-icons icon-simple-add"></i>
                  </base-button>
                  <base-button
                    round
                    :disabled="!model.id_jornada"
                    icon
                    type="success"
                    @click="modalEditJornada = true"
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                  <modal :show.sync="modalCadJornada">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Cadastro de Jornada
                      </h4>
                    </template>
                    <div>
                      <base-input
                        name="jornada"
                        class="col-sm-12"
                        placeholder="Descrição"
                        v-model.trim="descricaoJornada"
                      >
                      </base-input>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="modalCadJornada = false"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        :disabled="isLoading"
                        @click="cadastrarJornada()"
                        >Salvar</base-button
                      >
                    </template>
                  </modal>
                  <modal :show.sync="modalEditJornada">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Edição de Jornada
                      </h4>
                    </template>
                    <div>
                      <base-input
                        name="dataAdmissao"
                        class="col-sm-12"
                        placeholder="Descrição"
                        v-model.trim="model.nomeJornada"
                      >
                      </base-input>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="modalEditJornada = false"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        :disabled="isLoading"
                        @click="
                          editarJornada(model.id_jornada, model.nomeJornada)
                        "
                        >Salvar</base-button
                      >
                    </template>
                  </modal>
                </div>

                <div class="row" v-show="banco == 'dbsensamanaus'">
                  <el-select
                    name="id_jornada2"
                    class="select-primary col-sm-6 pagination-select"
                    v-model="model.id_jornada2"
                    placeholder="Jornada para 2ª Matricula"
                  >
                    <el-option
                      v-for="item in listJornadas"
                      :key="item.id"
                      class="select-primary"
                      :label="item.descricao"
                      :value="item.id"
                      >{{ item.descricao }}</el-option
                    >
                  </el-select>
                  <base-button
                    round
                    :disabled="!model.id_jornada2"
                    icon
                    type="success"
                    @click="modalEditJornada2 = true"
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                  <modal :show.sync="modalEditJornada2">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Edição de Jornada
                      </h4>
                    </template>
                    <div>
                      <base-input
                        name="dataAdmissao"
                        class="col-sm-12"
                        placeholder="Descrição"
                        v-model.trim="model.nomeJornada2"
                      >
                      </base-input>
                    </div>
                    <template slot="footer">
                      <base-button
                        type="danger"
                        @click="modalEditJornada = false"
                        >Fechar</base-button
                      >
                      <base-button
                        type="success"
                        :disabled="isLoading"
                        @click="
                          editarJornada(model.id_jornada2, model.nomeJornada2)
                        "
                        >Salvar</base-button
                      >
                    </template>
                  </modal>
                </div>

                <div class="row mt-2">
                  <el-select
                    name="tipo_batida"
                    required
                    class="select-primary col-sm-6 pagination-select"
                    v-model="model.tipo_batida"
                    placeholder="Tipo Registro de Ponto"
                    :class="error.tipo_batida === true ? 'has-danger' : ''"
                  >
                    <el-option
                      v-for="item in listTiposBatidas"
                      :key="item.id"
                      class="select-primary"
                      :label="item.descricao"
                      :value="item.id"
                      >{{ item.descricao }}</el-option
                    >
                  </el-select>
                  <el-select
                    name="empregador"
                    required
                    class="select-success col-sm-6 pagination-select"
                    v-model="model.empregador"
                    :class="error.empregador === true ? 'has-danger' : ''"
                    placeholder="Empresa Contratante"
                  >
                    <el-option
                      v-for="item in listEmpregadores"
                      :key="item.id"
                      class="select-success"
                      :label="item.local"
                      :value="item.id"
                      >{{ item.local }}</el-option
                    >
                  </el-select>
                </div>
              </div>
            </div>

            <div
              v-show="itemMenu == 4"
              class="tab-pane fade"
              :class="itemMenu == 4 ? 'show active' : ''"
            >
              <div class="row justify-content-center">
                <div class="row">
                  <base-input
                    name="data"
                    class="col-sm-6"
                    type="tel"
                    v-mask="'##/##/####'"
                    required
                    placeholder="Data"
                    v-model="model.dataContribuicao"
                  />
                  <base-input
                    name="valor"
                    class="col-sm-6"
                    required
                    placeholder="Valor"
                    v-model="model.valorContribuicao"
                  />
                </div>
              </div>
            </div>

            <div
              v-show="itemMenu == 5"
              class="tab-pane fade"
              :class="itemMenu == 5 ? 'show active' : ''"
            >
              <div class="row justify-content-center">
                <div class="row">
                  <div
                    class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
                  >
                    <label class="col-12 col-form-label mb-0"
                      >Feriados serão Extras:</label
                    >
                    <base-radio
                      class="ml-3 mt-0 col-2"
                      name="1"
                      v-model="model.feriado"
                      >100%</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="2"
                      v-model="model.feriado"
                      >{{
                        listParametrizacao.rotuloHorasExtras
                          ? listParametrizacao.rotuloHorasExtras
                          : "50%"
                      }}</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="3"
                      v-model="model.feriado"
                      >Dia Normal</base-radio
                    >
                  </div>

                  <div
                    class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
                  >
                    <label class="col-12 col-form-label mb-0"
                      >Folgas serão Extras:</label
                    >
                    <base-radio
                      class="ml-3 mt-0 col-2"
                      name="1"
                      v-model="model.folga"
                      >100%</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="2"
                      v-model="model.folga"
                      >{{
                        listParametrizacao.rotuloHorasExtras
                          ? listParametrizacao.rotuloHorasExtras
                          : "50%"
                      }}</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="3"
                      v-model="model.folga"
                      >Conforme escala</base-radio
                    >
                  </div>

                  <div
                    class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
                  >
                    <label class="col-12 col-form-label mb-0"
                      >Sábados serão Extras:</label
                    >
                    <base-radio
                      class="ml-3 mt-0 col-2"
                      name="1"
                      v-model="model.sabado"
                      >100%</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="2"
                      v-model="model.sabado"
                      >{{
                        listParametrizacao.rotuloHorasExtras
                          ? listParametrizacao.rotuloHorasExtras
                          : "50%"
                      }}</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="3"
                      v-model="model.sabado"
                      >Conforme escala</base-radio
                    >
                  </div>

                  <div
                    class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
                  >
                    <label class="col-12 col-form-label mb-0"
                      >Domingos serão Extras:</label
                    >
                    <base-radio
                      class="ml-3 mt-0 col-2"
                      name="1"
                      v-model="model.domingo"
                      >100%</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="2"
                      v-model="model.domingo"
                      >{{
                        listParametrizacao.rotuloHorasExtras
                          ? listParametrizacao.rotuloHorasExtras
                          : "50%"
                      }}</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="3"
                      v-model="model.domingo"
                      >Conforme escala</base-radio
                    >
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
                  >
                    <label class="col-12 col-form-label mb-0"
                      >Categoria Banco de Horas:</label
                    >
                    <base-radio
                      class="ml-3 mt-0 col-12"
                      name="sim"
                      v-model="model.bancoHora"
                      >Com Banco de Horas
                    </base-radio>
                    <base-input
                      v-show="model.bancoHora == 'sim'"
                      name="saldoInicial"
                      class="ml-3 mt-0 col-12"
                      type="text"
                      placeholder="Saldo Inicial"
                      v-model="model.saldoInicial"
                    />

                    <el-select
                      v-show="model.bancoHora == 'sim'"
                      name="modoBancoHoras"
                      required
                      class="ml-3 select-success col-12 pagination-select"
                      v-model="model.modoBancoHoras"
                      placeholder="Modo do Banco de Horas"
                    >
                      <el-option
                        v-for="item in listModoAbonos"
                        :key="item.id"
                        class="select-success"
                        :label="item.descricao"
                        :value="item.id"
                        >{{ item.descricao }}</el-option
                      >
                    </el-select>

                    <base-radio
                      class="ml-3 col-12"
                      name="nao"
                      v-model="model.bancoHora"
                      >Sem Banco de Horas</base-radio
                    >
                  </div>

                  <div
                    class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
                  >
                    <label class="col-12 col-form-label mb-0"
                      >Categoria Pré-assinalação:</label
                    >
                    <base-radio
                      class="ml-3 mt-0 col-12"
                      name="nao"
                      v-model="model.assinalacao"
                      >Não</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="sim"
                      v-model="model.assinalacao"
                      >Sim</base-radio
                    >
                  </div>

                  <div
                    class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
                  >
                    <label class="col-12 col-form-label mb-0"
                      >Permite Registrar Ponto Off-line?</label
                    >
                    <base-radio
                      class="ml-3 mt-0 col-12"
                      name="0"
                      v-model="model.offlineapp"
                      >Não</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="1"
                      v-model="model.offlineapp"
                      >Sim</base-radio
                    >
                  </div>

                  <div
                    class="col-3 d-flex text-left justify-content-center justify-content-sm-between flex-wrap checkbox-radios"
                  >
                    <label class="col-12 col-form-label mb-0"
                      >Leitura de QRCode no App Celular?</label
                    >
                    <base-radio
                      class="ml-3 mt-0 col-12"
                      name="0"
                      v-model="model.qrcode"
                      >Não</base-radio
                    >
                    <base-radio
                      class="ml-3 col-12"
                      name="1"
                      v-model="model.qrcode"
                      >Sim</base-radio
                    >
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="itemMenu == 6"
              class="tab-pane fade"
              :class="itemMenu == 6 ? 'show active' : ''"
            >
              <div class="row justify-content-center mt-3">
                <modal-rec-facial-v2
                  class=" col-4 justify-content-center"
                  :cpf="model.cpf"
                  :cnpj="$cookies.get('cnpj')"
                  :name="model.nome"
                  :sendFoto="sendFoto"
                  :hasLoading="false"
                  endpoint="/updateFoto"
                  :isJson="true"
                  @statusfoto="statusfoto"
                  @success="onUpdateSuccess"
                />
              </div>
            </div>
          </div>

          <div class="row d-flex justify-content-end mt-3">
            <!-- <div class="col-sm-3">
            <base-button type="success"><i class="tim-icons icon-minimal-left"></i>Voltar</base-button>
          </div> -->
            <div class="col-sm-3">
              <base-button
                v-if="itemMenu !== 1"
                block
                type="success"
                @click="controlarMenu(-1)"
                >Anterior</base-button
              >
            </div>

            <div class="col-sm-3 offset-6">
              <base-button
                v-if="itemMenu === 6"
                block
                type="success"
                :disabled="verifyDisabled() || isLoading"
                @click="verifyFoto()"
                >Cadastrar</base-button
              >

              <base-button
                v-if="itemMenu !== 6"
                block
                type="success"
                @click="controlarMenu(1)"
                >Próximo</base-button
              >
            </div>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="modalPreAssi">
      <template slot="header">
        <h4 class="modal-title">
          Cadastro de Pré Assinalação
        </h4>
      </template>
      <div>
        <base-checkbox v-model="model.preassi1" class="col-12" name="preassi1">
          Pré-assinalação Intervalo 1
        </base-checkbox>
        <base-checkbox v-model="model.preassi2" class="col-12" name="preassi2">
          Pré-assinalação Intervalo 2
        </base-checkbox>
        <base-checkbox v-model="model.preassi3" class="col-12" name="preassi3">
          Pré-assinalação Intervalo 3
        </base-checkbox>
      </div>
      <template slot="footer">
        <base-button type="success" @click="modalPreAssi = false"
          >Salvar</base-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import { Card, BaseInput, BaseRadio } from "@/components/index";

import estadosjs from "../../pages/Forms/Wizard/Funcionarios/estados";
import cidadesjs from "../../pages/Forms/Wizard/Funcionarios/cidades.json";

import ModalRecFacialV2 from "../../pages/Pages/RegistrarPontoFuncionario/ModalRecFacialV2.vue";

import swal from "sweetalert2";
import Modal from "@/components/Modal.vue";
export default {
  data() {
    return {
      isLoading: false,
      title: "Dados Pessoais",
      wizardModel: {},

      itemMenu: 1,

      estados: estadosjs,
      estadoSelecionado: "",
      cidades: [],

      cpf: "",

      listDepartamentos: [],
      listJornadas: [],
      listTiposBatidas: [
        {
          id: 1,
          descricao: "Facial via App no celular do funcionário",
        },
        {
          id: 2,
          descricao: "Biometria facial ou dedo ou App Kiosque uso coletivo",
        },
        {
          id: 3,
          descricao: "Todas as opções",
        },
      ],
      listFuncoes: [],
      listModoAbonos: [
        { id: 1, descricao: "Extras e Atrasos" },
        { id: 2, descricao: "Somente Extras" },
        { id: 3, descricao: "Somente Atrasos" },
      ],
      listEmpregadores: [],
      listParametrizacao: [],
      descricaoCadFunc: "",
      descricaoJornada: "",
      horaIntrajornadaCadFunc: "01:00",
      intrajornadaCadFunc: true,
      descricaoCadDep: "",
      modalCadastrarFunc: false,
      modalCadastrarDep: false,
      modalEditarFunc: false,
      modalEditarDep: false,
      modalPreAssi: false,
      modalEditJornada: false,
      modalEditJornada2: false,
      modalCadJornada: false,

      fotoTirada: false,

      model: {
        nome: "",
        email: "",
        matricula: "",
        matricula2: "",
        telefone: "",
        codigo: "",
        endereco: "",
        bairro: "",
        cep: "",
        complemento: "",
        uf: "",
        cidade: "",
        grauInstrucao: "",
        sexo: "",
        estadoCivil: "",
        dataNascimento: "",
        pai: "",
        mae: "",

        ctps: "",
        serie: "",
        dateExpedicaoCtps: "",
        ci: "",
        orgaoExpeditor: "",
        dateExpedicaoCi: "",
        cpf: "",
        tituloEleitor: "",
        zona: "",
        secao: "",
        certificadoReservista: "",
        categoria: "",
        pisPasep: "",
        dataPisPasep: "",
        habiltProfiss: "",
        registroProf: "",
        orgaoRegistro: "",

        dataAdmissao: "",
        horasContratadas: "",
        valorPlanoSaude: "",
        nrContaBancaria: "",
        nrBanco: "",
        chefia: "",
        funcao: "",
        departamento: "",

        dataContribuicao: "",
        valorContribuicao: "",

        bancoHora: "nao",
        feriado: "1",
        assinalacao: "nao",
        tipo_batida: 1,
        empregador: "",
        sabado: "3",
        saldoInicial: "00:00",
        modoBancoHoras: 1,
        domingo: "3",
        folga: "1",
        offlineapp: "0",
        qrcode: "0",
        nomeFuncao: "",
        intrajornada: true,
        horaIntrajornada: "01:00",
        nomeDepartamento: "",
        nomeJornada: "",
        nomeJornada2: "",
        preassi1: false,
        preassi2: false,
        preassi3: false,
        id_jornada: "",
        id_jornada2: "",
      },
      error: {
        nome: "",
        email: "",
        cpf: "",
        funcao: "",
        departamento: "",
        tipo_batida: "",
        empregador: "",
        id_jornada: "",
        matricula2: "",
      },
      sendFoto: "",
      banco: "",
    };
  },
  components: {
    Modal,
    Card,
    BaseInput,
    BaseRadio,
    ModalRecFacialV2,
  },

  mounted() {
    this.banco = this.$cookies.get("db");
    this.listarParametrizacao();
    this.listarFuncoes();
    this.listarDepartamentos();
    this.listarEmpregadores();
    this.listarJornadas();
  },

  methods: {
    mostraModalPreAssin() {
      this.modalPreAssi = true;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },

    verifyDisabled() {
      if (
        !this.model.nome ||
        !this.model.cpf ||
        !this.model.funcao ||
        !this.model.departamento ||
        !this.sendFoto
      ) {
        return true;
      } else {
        return false;
      }
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    statusfoto(event) {
      this.sendFoto = event;
    },

    controlarMenu(valor) {
      //validar campos de acordo com o menu selecionado
      const alterarValor = (valor) => {
        if (valor === -1 && this.itemMenu > 1) {
          this.itemMenu -= 1;
        } else if (valor === 1 && this.itemMenu < 6) {
          this.itemMenu += 1;
        }
      };

      switch (this.itemMenu) {
        case 1:
          if (!this.model.nome || this.model.nome === "")
            this.error.nome = true;
          else this.error.nome = false;

          if (
            this.model.matricula2 &&
            this.model.matricula2 == this.model.matricula
          ) {
            this.error.matricula2 = true;
          } else this.error.matricula2 = false;

          if (this.model.nome !== "" && !this.error.matricula2) {
            alterarValor(valor);
          }
          break;
        case 2:
          if (!this.model.cpf || this.model.cpf === "") this.error.cpf = true;
          else this.error.cpf = false;

          if (this.model.cpf !== "") {
            alterarValor(valor);
          }
          break;
        case 3:
          if (!this.model.funcao || this.model.funcao === "")
            this.error.funcao = true;
          else this.error.funcao = false;

          if (!this.model.departamento || this.model.departamento === "")
            this.error.departamento = true;
          else this.error.departamento = false;

          if (!this.model.tipo_batida || this.model.tipo_batida === "")
            this.error.tipo_batida = true;
          else this.error.tipo_batida = false;

          if (!this.model.empregador || this.model.empregador === "") {
            this.error.empregador = true;
          } else this.error.empregador = false;

          if (this.banco === "dbsensamanaus") {
            if (!this.model.id_jornada || this.model.id_jornada === "") {
              this.error.id_jornada = true;
            } else this.error.id_jornada = false;
          } else {
            this.error.id_jornada = false;
          }

          if (
            this.model.funcao !== "" &&
            this.model.departamento !== "" &&
            this.model.tipo_batida !== "" &&
            this.model.empregador !== "" &&
            !this.error.id_jornada
          ) {
            alterarValor(valor);
          }
          break;
        case 4:
          alterarValor(valor);
          break;
        case 5:
          alterarValor(valor);
          break;
        case 6:
          alterarValor(valor);
          break;
      }
    },

    verifyFoto() {
      if (this.sendFoto === "" || this.sendFoto === false) {
        this.showSwal(
          "auto-close",
          "Aviso",
          "Item foto é obrigatório!",
          "warning",
        );
      } else {
        this.isLoading = true;
        // Primeiro cadastramos o funcionário, depois enviamos a foto
        this.cadastrarFuncionario();
      }
    },

    onUpdateSuccess() {
      this.isLoading = false;
      this.showSwal(
        "auto-close",
        "Sucesso",
        "Cadastro realizado com sucesso!",
        "success",
      );
      setTimeout(() => {
        this.$router.push("/pesquisarEmpregados");
      }, 1000);
    },

    verificarCpf(cpf) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        cnpj: this.$cookies.get("cnpj"),
        cpf: cpf,
      };

      this.axios
        .post("/api/empregado/verificarCpfEmpregado", bodyFormData)
        .then((response) => {
          th.isLoading = false;

          if (response.data.data.dados[0].PODE_CADASTRAR == "S") {
            th.model.cpf = cpf;
            th.model.pisPasep = cpf;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Este CPF já possui cadastro!",
              "error",
            );
            th.cpf = "";
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Este CPF já possui cadastro!",
            "error",
          );
          th.cpf = "";
        });
    },
    verificarCodigo() {
      if (this.$route.params.typeCad == 2) return;

      const codigo = this.model.codigo;
      if (codigo == "" || !codigo || codigo == 0) return;

      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        codigo: codigo,
      };

      this.axios
        .post("/api/empregado/verificarCodigoEmpregado", bodyFormData)
        .then((response) => {
          th.isLoading = false;

          if (response.data.data.dados[0].PODE_CADASTRAR == "S") {
            th.model.codigo = codigo;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Este Código já possui cadastro!",
              "error",
            );
            th.model.codigo = "";
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Este Código já possui cadastro!",
            "error",
          );
          th.model.codigo = "";
        });
    },

    cadastrarFuncao() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        ds_funcao: this.descricaoCadFunc,
        ativo: "S",
        intrajornada: this.intrajornadaCadFunc ? 1 : 0,
        horaIntrajornada: this.horaIntrajornadaCadFunc,
      };
      this.axios
        .post("/api/funcoes/inserirFuncaoDescAndAtivo", bodyFormData)
        .then(() => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Cadastro realizado com sucesso!",
            "success",
          );
          th.modalCadastrarFunc = false;
          th.listarFuncoes();
          // th.dialogCadastrarMotivo = false
          // th.listarMotivoAfastamento()
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao realizar cadastro!",
            "error",
          );
        });
    },
    editarFuncao() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.model.funcao,
        descricao: this.model.nomeFuncao,
        intrajornada: this.model.intrajornada ? 1 : 0,
        horaIntrajornada: this.model.horaIntrajornada,
      };
      this.axios
        .post("/api/funcoes/editar", bodyFormData)
        .then(() => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Edição realizada com sucesso!",
            "success",
          );
          th.modalEditarFunc = false;
          th.listarFuncoes();
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao realizar cadastro!",
            "error",
          );
        });
    },
    cadastrarDepartamento() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        descricao: this.descricaoCadDep,
        ativo: "S",
      };
      this.axios
        .post("/api/departamento/cadastrarDepartamento", bodyFormData)
        .then(() => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Cadastro realizado com sucesso!",
            "success",
          );
          th.modalCadastrarDep = false;
          th.descricao = "";
          th.listarDepartamentos();
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao realizar cadastro!",
            "error",
          );
        });
    },
    cadastrarJornada() {
      const th = this;
      this.isLoading = true;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        descricao: this.descricaoJornada,
      };
      this.axios
        .post("/api/jornadaDescricao/criar", bodyFormData)
        .then(() => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Cadastro realizado com sucesso!",
            "success",
          );
          th.modalCadJornada = false;
          th.listarJornadas();
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao realizar cadastro!",
            "error",
          );
        });
    },
    editarDepartamento() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.model.departamento,
        descricao: this.model.nomeDepartamento,
      };
      this.axios
        .post("/api/departamento/editar", bodyFormData)
        .then(() => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Edição realizada com sucesso!",
            "success",
          );
          th.modalEditarDep = false;
          th.listarDepartamentos();
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao realizar edição!",
            "error",
          );
        });
    },
    editarJornada(id_jornada, nomeJornada) {
      const th = this;
      this.isLoading = true;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: id_jornada,
        descricao: nomeJornada,
      };
      this.axios
        .post("/api/jornadaDescricao/atualizar", bodyFormData)
        .then(() => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Edição realizada com sucesso!",
            "success",
          );
          th.modalEditJornada = false;
          th.modalEditJornada2 = false;
          th.listarJornadas();
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao realizar edição!",
            "error",
          );
        });
    },
    listarFuncoes() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/funcoes/listarDescFuncoes", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          th.listFuncoes = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar departamentos!",
            "error",
          );
        });
    },

    listarDepartamentos() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/departamento/listarDepartamentos", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          th.listDepartamentos = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar departamentos!",
            "error",
          );
        });
    },

    listarJornadas() {
      if (this.banco === "dbsensamanaus") {
        let th = this;
        this.isLoading = true;

        let bodyFormData = {
          setDB: this.banco,
        };
        this.axios
          .post("/api/jornadaDescricao/listarJornadas", bodyFormData)
          .then((response) => {
            th.isLoading = false;
            th.listJornadas = response.data.data;
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao listar jornadas!",
              "error",
            );
          });
      }
    },

    listarEmpregadores() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          th.listEmpregadores = response.data.data.dados;
          this.model.empregador = response.data.data.dados[0].id;
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar empresas!",
            "error",
          );
        });
    },

    listarParametrizacao() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/parametrizacao/listarParametrizacao", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          if (response.data.dados.status) {
            th.listParametrizacao = response.data.dados.dados[0];
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar Parametrização!",
            "error",
          );
        });
    },

    cadastrarFuncionario() {
      let th = this;
      // this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        cpf: this.model.cpf.replace(/[. - / - -]/g, ""),
        numero_pis: this.model.pisPasep ? this.model.pisPasep : "",
        data_pis: this.model.dataPisPasep ? this.model.dataPisPasep : null,
        nome: this.model.nome,
        numero_matricula_ctps: this.model.matricula ? this.model.matricula : "",
        numero_matricula_ctps2: this.model.matricula2 || "",
        codigo: parseInt(this.model.codigo),
        endereco: this.model.endereco ? this.model.endereco : "",
        complemento: this.model.complemento ? this.model.complemento : "",
        bairro: this.model.bairro ? this.model.bairro : "",
        cep: this.model.cep ? this.model.cep.replace(/[. - / - -]/g, "") : "",
        estado: this.model.uf ? this.model.uf : "",
        cidade: this.model.cidade ? this.model.cidade : "",
        telefone: this.model.telefone
          ? this.model.telefone.replace(/[. - ( - ) - / - -]/g, "")
          : "",
        email: this.model.email ? this.model.email : "",
        escolaridade: this.model.grauInstrucao ? this.model.grauInstrucao : "",
        sexo: this.model.sexo ? this.model.sexo : "",
        filiacao_pai: this.model.pai ? this.model.pai : "",
        filiacao_mae: this.model.mae ? this.model.mae : "",
        data_nascimento: this.model.dataNascimento
          ? this.model.dataNascimento
          : null,
        ctps: this.model.ctps ? this.model.ctps : "",
        ctps_serie: this.model.serie ? this.model.serie : "",
        expedicao: this.model.dateExpedicaoCtps
          ? this.model.dateExpedicaoCtps
          : "",
        rg: this.model.ci ? this.model.ci : "",
        orgao_expedicao: this.model.orgaoExpeditor
          ? this.model.orgaoExpeditor
          : "",
        data_expedicao: this.model.dateExpedicaoCi
          ? this.model.dateExpedicaoCi
          : null,
        titulo_numero: this.model.tituloEleitor ? this.model.tituloEleitor : "",
        titulo_zona: this.model.zona ? this.model.zona : "",

        titulo_secao: this.model.secao ? this.model.secao : "",
        cert_reservista_ra: this.model.certificadoReservista
          ? this.model.certificadoReservista
          : "",
        certificado_reservista_categoria: this.model.categoria
          ? this.model.categoria
          : "",
        certificado_reservista_serie: "",
        data_adimissao: this.model.dataAdmissao
          ? this.model.dataAdmissao
          : null,
        horas_contradadas_mes: this.model.horasContratadas
          ? this.model.horasContratadas
          : null,
        funcao: this.model.funcao ? this.model.funcao : "",

        departamento: this.model.departamento ? this.model.departamento : "",
        tipo_batida: this.model.tipo_batida ? this.model.tipo_batida : "",
        contribuicao_sindical_data: this.model.dataContribuicao
          ? this.model.dataContribuicao
          : null,
        contribuicao_sindical_valor: this.model.valorContribuicao
          ? this.model.valorContribuicao
          : 0,
        valor_plano_saude: this.model.valorPlanoSaude
          ? this.model.valorPlanoSaude
          : null,
        nr_conta_bancaria: this.model.nrContaBancaria
          ? this.model.nrContaBancaria
          : "",
        banco: this.model.nrBanco ? this.model.nrBanco : "",
        id_empregador: this.model.empregador ? this.model.empregador : "", //empresa contratante
        feriado: this.model.feriado,
        assinalacao: this.model.assinalacao,
        bancoHora: this.model.bancoHora,
        //esse aqui nao é pra alterar, sempre pega daqui msm
        empregador_id: this.$cookies.get("idEmpregador")
          ? this.$cookies.get("idEmpregador")
          : 1,
        saldoInicial: this.model.saldoInicial
          ? this.model.saldoInicial + ":00"
          : "00:00:00",
        sabado: this.model.sabado,
        domingo: this.model.domingo,
        folga: this.model.folga,
        offlineapp: Number(this.model.offlineapp),
        qrcode: Number(this.model.qrcode),
        preassi1: "0",
        preassi2: "0",
        preassi3: "0",
        id_jornada: this.model.id_jornada,
        id_jornada2: this.model.id_jornada2,
        chefia: this.model.chefia,
        modoBancoHoras: this.model.modoBancoHoras || 1,
      };

      if (bodyFormData.assinalacao == "sim") {
        bodyFormData.preassi1 = this.model.preassi1 ? "1" : "0";
        bodyFormData.preassi2 = this.model.preassi2 ? "1" : "0";
        bodyFormData.preassi3 = this.model.preassi3 ? "1" : "0";
      }

      this.axios
        .post("/api/empregado/cadastrarEmpregado", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          if (!response.data.data.status) {
            th.showSwal("auto-close", "Erro", response.data.data.err, "error");
          } else {
            // Dispara o envio da foto agora que o usuário já existe
            th.$root.$emit("enviarFoto", true);
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao cadastrar funcionário!",
            "error",
          );
          // th.$router.push("/pesquisarEmpregados")
        });
    },
  },

  watch: {
    "model.matricula": function(newVal) {
      if (!newVal) {
        this.model.matricula2 = "";
      }
    },
    "model.assinalacao": function(newVal) {
      if (newVal == "sim") {
        this.mostraModalPreAssin();
      }
    },
    estadoSelecionado(newVal) {
      // this.model.cidade = ""
      let estado = this.estados.filter((dados) => {
        if (dados.ID == newVal) {
          return dados;
        }
      });
      this.model.uf = estado[0].Sigla;

      this.cidades = cidadesjs;

      this.cidades = this.cidades.filter((dados) => {
        if (dados.Estado == newVal) {
          return dados;
        }
      });
    },

    cpf(newVal) {
      if (this.$route.params.typeCad == 1) {
        //create
        if (newVal.length == 14) {
          this.verificarCpf(newVal.replace(/[. - / - -]/g, ""));
        }
      } else if (this.$route.params.typeCad == 2) {
        console.log(newVal);
      } //update
    },

    itemMenu(newVal) {
      switch (newVal) {
        case 1:
          this.title = "Dados Pessoais";
          break;
        case 2:
          this.title = "Documentação";
          break;
        case 3:
          this.title = "Dados Empregatícios";
          break;
        case 4:
          this.title = "Contribuição Sindical";
          break;
        case 5:
          this.title = "Configurações";
          break;
        case 6:
          this.title = "Foto";
          break;
        default:
          this.title = "";
      }
    },

    nome() {
      this.model.nome = String(this.model.nome).toUpperCase();
    },
    email() {
      this.model.email = String(this.model.email).toLowerCase();
    },
    "model.funcao": function(newVal) {
      const dadosFuncoes = this.listFuncoes.find(
        (funcao) => funcao.id == newVal,
      );

      this.model.nomeFuncao = dadosFuncoes.descricao;
      this.model.intrajornada = dadosFuncoes.intrajornada == 1 ? true : false;
      this.model.horaIntrajornada = dadosFuncoes.horaIntrajornada;
    },
    "model.departamento": function(newVal) {
      this.model.nomeDepartamento = this.listDepartamentos.find(
        (dep) => dep.id == newVal,
      ).descricao;
    },
    "model.id_jornada": function(newVal) {
      this.model.nomeJornada = this.listJornadas.find(
        (dep) => dep.id == newVal,
      ).descricao;
    },

    "model.id_jornada2": function(newVal) {
      this.model.nomeJornada2 = this.listJornadas.find(
        (dep) => dep.id == newVal,
      ).descricao;
    },
  },

  computed: {
    nome() {
      return this.model.nome;
    },
    email() {
      return this.model.email;
    },
  },
};
</script>
<style></style>
